import { PureComponent } from "react";
import UserStore from "~/stores/UserStore";
import BranchStore, { Branch, MergeQueue, Project } from "~/stores/BranchStore";

import BranchComponent from "~/components/pipeline/BranchList/Branch";
import MergeQueueBaseBranch from "~/components/pipeline/BranchList/MergeQueueBaseBranch";

type Props = {
  store: BranchStore;
};

type State = {
  branches: Array<Branch>;
  project: Project;
  mergeQueues: Array<MergeQueue>;
};

export default class BranchList extends PureComponent<Props, State> {
  state = {
    branches: this.props.store.all(),
    project: this.props.store.getProject(),
    mergeQueues: this.props.store.getMergeQueues(),
  };

  componentDidMount() {
    UserStore.addChangeListener(this.handleStoreChange);
    this.props.store.on("change", this.handleStoreChange);
  }

  componentWillUnmount() {
    UserStore.removeChangeListener(this.handleStoreChange);
    this.props.store.off("change", this.handleStoreChange);
  }

  handleStoreChange = () => {
    this.setState({
      branches: this.props.store.all(),
      mergeQueues: this.props.store.getMergeQueues(),
    });
  };

  render() {
    return (
      <div className="flex flex-col items-center">
        {this.state.mergeQueues.length > 0 && (
          <>
            {this.state.mergeQueues.map((mergeQueue) => (
              <MergeQueueBaseBranch
                key={mergeQueue.baseBranch}
                mergeQueue={mergeQueue}
                store={this.props.store}
              />
            ))}

            <div className="border-gray mb-6 mt-1 w-96 border-t" />
          </>
        )}

        {this.state.branches.map((branch) => (
          <BranchComponent
            key={branch.name}
            project={this.state.project}
            branch={branch}
            store={this.props.store}
          />
        ))}
      </div>
    );
  }
}
